@let seatIcon = getIconForServiceCategory(Category.SEAT);
@let plusIcon = SvgLibraryIcon.PLUS;

<div
  class="seat-bundle-toggle-container rounded-large border ms-medium-b overflow-hidden"
  [class.heather-600-border]="accented()"
  [class.border-primary]="accented()"
  aria-live="polite"
>
  <div class="flex flex--space-between wrap white-bg surface-primary" data-testid="seat-bundle-toggle-inner-container">
    <div class="heather-700-bg surface-accent flex flex--self-stretch flex--center ps-xsmall icon-container">
      <fcom-icon class="icon-medium white-text text-icon-reversed flex--self-center" [name]="seatIcon" />
      <fcom-icon class="icon-small white-text text-icon-reversed flex--self-center" [name]="plusIcon" />
      <fcom-icon class="icon-medium white-text text-icon-reversed flex--self-center" [name]="categoryIcon()" />
    </div>

    <div class="flex flex--basis-full ps-small rounded-top-large rounded-bottom-large">
      <div class="flex flex--column flex--basis-full text-container">
        <div class="flex flex--space-between flex--middle ps-xxsmall-b">
          <p>
            <span
              class="font-body-1 bold-type ps-xsmall-r font-body-medium-bold"
              data-testid="seat-bundle-toggle-combo-title-text"
            >
              {{ `ancillaries.${category()}.promotionCard.title.${bundleTranslationKey()}` | finLocalization }}
            </span>
          </p>
          @if (bundleHeld()) {
            <fcom-tag
              class="flex--self-start"
              [theme]="TagTheme.SUCCESS"
              [attr.data-testid]="'seat-bundle-combo-added-tag'"
            >
              <fcom-icon class="icon-small" [name]="SvgLibraryIcon.CHECKMARK" />
              <span class="ms-xxsmall-l nowrap">{{
                'ancillaries.bundle.toggle.tagText.comboAdded' | finLocalization
              }}</span>
            </fcom-tag>
          }
        </div>

        <div class="description-container">
          <p class="font-body-2 font-body-medium ps-xsmall-t" data-testid="seat-bundle-toggle-description">
            {{ `ancillaries.${category()}.promotionCard.description.${bundleTranslationKey()}` | finLocalization }}
          </p>
        </div>
        <div class="flex flex--space-between ps-medium-t toggle-footer">
          <div>
            @if (category() !== Category.SEAT_WIFI) {
              <div class="flex flex--middle nowrap">
                <fcom-link
                  [attr.data-testid]="category() + '-details-link'"
                  (afterNavigation)="openModal = true"
                  [size]="LinkSize.SMALL"
                  [icon]="{ name: SvgLibraryIcon.INFO_BLOCK, position: IconPosition.LEFT }"
                >
                  {{ `ancillaries.${category()}.detailsLinkTitle` | finLocalization }}
                </fcom-link>
              </div>
            }
          </div>

          @switch (variant()) {
            @case (BundlePromotionCardVariant.UPGRADE_SEAT_TO_BUNDLE) {
              <fcom-button
                class="flex--self-end"
                data-testid="add-bundle-upsell-price-button"
                [theme]="ButtonTheme.LIGHT_PRIMARY_NORDIC_BLUE"
                [text]="
                  'ancillaries.bundle.toggle.buttonText.addForPrice'
                    | finLocalization
                      : { price: bundleUpsellPrice() | finNonZeroAmount: false | finPrice | finEmpty: '' }
                "
                (clickBtn)="emitToggle()"
              />
            }
            @case (BundlePromotionCardVariant.DOWNGRADE_TO_SEAT) {
              <fcom-button
                class="flex--self-end"
                data-testid="remove-ancillary-button"
                [theme]="ButtonTheme.LIGHT_TERTIARY_GHOST"
                [icon]="{ name: SvgLibraryIcon.TRASH, position: IconPosition.LEFT }"
                [text]="`ancillaries.${category()}.removeAncillaryButton` | finLocalization"
                (clickBtn)="emitToggle()"
              />
            }
            @case (BundlePromotionCardVariant.REMOVE_BUNDLE) {
              <fcom-button
                class="flex--self-end"
                data-testid="remove-bundle-button"
                [theme]="ButtonTheme.LIGHT_TERTIARY_GHOST"
                [icon]="{ name: SvgLibraryIcon.TRASH, position: IconPosition.LEFT }"
                [text]="'ancillaries.bundle.toggle.buttonText.removeCombo' | finLocalization"
                (clickBtn)="emitToggle()"
              />
            }
            @case (BundlePromotionCardVariant.NOT_INTERACTIVE) {
              @let lowestPrice = bundleOffersLowestPrice();
              @if (lowestPrice?.money) {
                <div class="bundle-price flex flex--column ps-xsmall-l" data-testid="bundle-offers-toggle-price">
                  <div class="flex flex--middle flex--end">
                    <span
                      class="font-body-2 font-body-small nowrap"
                      [class.heather-700-text]="lowestPrice.originalPrice"
                      [class.text-icon-primary]="lowestPrice.originalPrice"
                      data-testid="bundle-offers-toggle-starting-from-label"
                      >{{ 'pricesStartingFrom' | finLocalization }}</span
                    >
                    <span
                      class="font-heading-5 font-title-small ps-xxsmall-l nowrap"
                      [class.heather-700-text]="lowestPrice.originalPrice"
                      [class.text-icon-primary]="lowestPrice.originalPrice"
                      data-testid="bundle-offers-toggle-price-amount"
                      >{{ lowestPrice.money | finPrice }}</span
                    >
                  </div>
                  @if (lowestPrice.originalPrice) {
                    <span
                      class="font-body-2 strike-through font-body-small nowrap"
                      data-testid="bundle-offers-toggle-original-price"
                      >{{ lowestPrice.originalPrice | finPrice }}</span
                    >
                  }
                </div>
              }
            }
          }
        </div>
      </div>
    </div>
  </div>
</div>

<fin-product-info-modal [open]="openModal" [serviceInfo]="serviceInfo()" (closeModal)="openModal = false" />
